import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

//fil out empty contaiers for each table, used for easy check if data exists or not
const initialState = {
    invoices: [],  
    invoiceDetails: {}, 
    invoiceFilter: {},
    equipment: [],
    customersList: [],
    rates: [],
    users: [],
};

//setting invoice data cache removes any old data to ensure doenst bog down site
const updateInvoice = (action) => {
    console.log('updateInvoice', action.items)
    let items = action.items;

    return {
        ...initialState,
        ...items,
    };
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_INVOICE:
      return updateInvoice(action);
    case actionTypes.RESET_INVOICE:
      return initialState;
    default:
      return state;
  }
};

export default invoiceReducer;
